module.exports = __webpack_public_path__ + "img/1477746675.697d47bc.jpg";